import {
  SELLERPOINTFORM_FETCHITEM_LOAD,
  SELLERPOINTFORM_FETCHITEM_SUCCEED,
  SELLERPOINTFORM_FETCHITEM_FAIL,
  SELLERPOINTFORM_EDITFORM_CHANGE,
  SELLERPOINTFORM_ENTER_RESET,
  SELLERPOINTFORM_CREATEITEM_LOAD,
  SELLERPOINTFORM_CREATEITEM_SUCCEED,
  SELLERPOINTFORM_CREATEITEM_FAIL,
  SELLERPOINTFORM_EDITITEM_LOAD,
  SELLERPOINTFORM_EDITITEM_SUCCEED,
  SELLERPOINTFORM_EDITITEM_FAIL,
  SELLERPOINTFORM_DELETEITEM_LOAD,
  SELLERPOINTFORM_DELETEITEM_SUCCEED,
  SELLERPOINTFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERPOINTFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case SELLERPOINTFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case SELLERPOINTFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case SELLERPOINTFORM_ENTER_RESET:
      return {}
    case SELLERPOINTFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case SELLERPOINTFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case SELLERPOINTFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case SELLERPOINTFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case SELLERPOINTFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case SELLERPOINTFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case SELLERPOINTFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case SELLERPOINTFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case SELLERPOINTFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case SELLERPOINTFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerPointForm.js